import React, { useEffect, useRef } from 'react';

const HeaderMobile = () => {
    const asideTogglerRef = useRef(null);
    const headerTogglerRef = useRef(null);
    const topbarTogglerRef = useRef(null);

    useEffect(() => {
        // Direct event handler for aside toggler
        const handleAsideToggle = (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.toggle("kt-aside--on");
        };

        // Direct event handler for header toggler
        const handleHeaderToggle = (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.toggle("kt-header-menu-wrapper--on");
        };

        // Direct event handler for topbar toggler
        const handleTopbarToggle = (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.toggle("kt-header__topbar--mobile-on");
        };

        const asideBtn = asideTogglerRef.current;
        const headerBtn = headerTogglerRef.current;
        const topbarBtn = topbarTogglerRef.current;

        if (asideBtn) {
            asideBtn.addEventListener("click", handleAsideToggle);
        }
        if (headerBtn) {
            headerBtn.addEventListener("click", handleHeaderToggle);
        }
        if (topbarBtn) {
            topbarBtn.addEventListener("click", handleTopbarToggle);
        }

        // Cleanup
        return () => {
            if (asideBtn) {
                asideBtn.removeEventListener("click", handleAsideToggle);
            }
            if (headerBtn) {
                headerBtn.removeEventListener("click", handleHeaderToggle);
            }
            if (topbarBtn) {
                topbarBtn.removeEventListener("click", handleTopbarToggle);
            }
        };
    }, []);

    return (
        <div id="kt_header_mobile" className="kt-header-mobile kt-header-mobile--fixed">
            <div className="kt-header-mobile__logo">
                <a href="/">
                    <img alt="Logo" src="./assets/media/logos/alb.png" style={{ height: 40 }} />
                </a>
            </div>
            <div className="kt-header-mobile__toolbar">
                <button
                    ref={asideTogglerRef}
                    className="kt-header-mobile__toggler kt-header-mobile__toggler--left"
                    id="kt_aside_mobile_toggler"
                    type="button"
                >
                    <span></span>
                </button>
                <button
                    ref={headerTogglerRef}
                    className="kt-header-mobile__toggler"
                    id="kt_header_mobile_toggler"
                    type="button"
                >
                    <span></span>
                </button>
                <button
                    ref={topbarTogglerRef}
                    className="kt-header-mobile__topbar-toggler"
                    id="kt_header_mobile_topbar_toggler"
                    type="button"
                >
                    <i className="flaticon-more"></i>
                </button>
            </div>
        </div>
    );
};

export default HeaderMobile;